/* eslint-disable react/react-in-jsx-scope */
import { Box, Container, Text } from '@chakra-ui/react';
import AgendaWrapper from '@/components/agenda/AgendaWrapper';
import EventCard, { IAgendaEvent } from '@/components/agenda/EventCard';

const agendaDay1: Array<IAgendaEvent[]> = [
  [
    {
      id: 'Day1_1',
      timing: {
        start: '10:00 AM',
        end: '11:00 AM',
      },
      normalHeading: 'Registration and Networking',
    },
    {
      id: 'Day1_2',
      timing: {
        start: '11:00 AM',
        end: '11:10 AM',
      },
      normalHeading: 'Welcome Address',
      speakers: [
        {
          name: 'Ashley Menezes',
          designation:
            'Chairperson, IVCA and Partner and COO, ChrysCapital Advisors',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-25at34031PM-30WWpjaGNT6P.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/ashley-menezes',
        },
      ],
      ytLink: 'https://youtu.be/Fqc9WulYtp4?feature=shared',
    },
    {
      id: 'Day1_2',
      timing: {
        start: '11:10 AM',
        end: '11:25 AM',
      },
      accentTag: 'Keynote Address',
      normalHeading: 'India’s Climate mitigation journey and its fiscal impact',
      speakers: [
        {
          name: 'Dr. V. Anantha Nageswaran',
          designation: 'Chief Economic Advisor to the Government of India',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-22at40340PM-CISgrOXpacyb.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/dr-v-anantha-nageswaran',
        },
      ],
      ytLink: 'https://youtu.be/T-QzMh05KGw?feature=shared',
    },
    {
      id: 'Day1_2',
      timing: {
        start: '11:25 AM',
        end: '11:40 AM',
      },
      //   accentTag: 'Keynote Address',
      normalHeading: 'Fireside Chat',
      speakers: [
        {
          name: 'Dr. V. Anantha Nageswaran',
          designation: 'Chief Economic Advisor to the Government of India',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-22at40340PM-CISgrOXpacyb.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/dr-v-anantha-nageswaran',
        },
        {
          name: 'Ashley Menezes',
          designation:
            'Chairperson, IVCA and Partner and COO, ChrysCapital Advisors',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-25at34031PM-30WWpjaGNT6P.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/ashley-menezes',
        },
      ],
      ytLink: 'https://youtu.be/TEDMpEyYxgw?feature=shared',
    },
    {
      id: 'Day1_3',
      timing: {
        start: '11:40 AM',
        end: '11:50 AM',
      },
      accentTag: 'Keynote Address',
      normalHeading:
        'Emergence and importance of India as an investment destination',
      speakers: [
        {
          name: 'Anita George',
          designation: 'Co-founder, Prosperete',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/anitageorge-PzNGMe8DikzM.webp',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/anita-george',
        },
      ],
      ytLink: 'https://youtu.be/uIMD24_8PPI?feature=shared',
    },

    {
      id: 'Day1_6',
      timing: {
        start: '11:50 AM',
        end: '12:30 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading: 'COP29 - Key takeaways for India',
      speakers: [
        {
          name: 'Shri. Soumitra Dasgupta',
          designation:
            'Director (Program), International Big Cat Alliance (IBCA), Mentor, WWF Fund, Advisor, UNDP, Member of Regional Empowered Committee of the MOEFCC',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-29at123233PM-tryGJ0d7K370.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/soumitra-dasgupta',
        },

        {
          name: 'Gaurav Kapoor',
          designation: 'Head – Capital, British High Commission',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/GauravKapoor-pKkzluB1lqV4.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/gaurav-kapoor',
        },
        {
          name: 'Mahua Acharya',
          designation: 'Founder CEO, INTENT',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Mahua-Acharya--GLUZccEGzm8z.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/mahua-acharya',
        },

        {
          name: 'Meyyappan Nagappan',
          designation: 'Partner, Trilegal (Moderator)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/MeyyappanN480KB-MqnYyVydlImP.JPG',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/meyyappan-nagappan',
        },
      ],
      ytLink: 'https://youtu.be/6AAsYdufGwk?feature=shared',
    },
    {
      id: 'Day1_10',
      timing: {
        start: '12:30 PM',
        end: '01:30 PM',
      },
      normalHeading: 'Networking Lunch',
    },
    {
      id: 'Day1_10',
      timing: {
        start: '01:30 PM',
        end: '01:40 PM',
      },
      normalHeading: 'Start-up Showcase Session',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
      ytLink: 'https://youtu.be/VuBxSdstfB4?feature=shared',
    },
    {
      id: 'Day1_7',
      timing: {
        start: '01:40 PM',
        end: '02:20 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading:
        'Scaling Up: Strategies for Increasing Climate Adaptation Investments',
      speakers: [
        {
          name: 'Shri Pradeep Ramakrishnan',
          designation:
            'Executive Director, International Financial Services Centres Authority (IFSCA)',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/prabhav-sharma',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/EDPRPhoto-bMZFnDJwxrLc.jpeg',
        },
        {
          name: 'Annu Talreja',
          designation: 'Founder & CEO, Accacia',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/annu-talreja',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/image001-vxmPzQfzNDld.jpg',
        },
        {
          name: 'Akshay Panth',
          designation: 'Chief Investment Officer, Neev Fund',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/akshay-panth',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Akshaypanth-01TStMkZL6f3.jpg',
        },
        {
          name: 'Karan Mohla',
          designation: 'Partner, B Capital Group',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/karan-mohla',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/karanmohla-OaJN9LBTXawG3.jpg',
        },
        {
          name: 'Samir Shah',
          designation: 'Managing Partner, Peak Sustainability Ventures',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/samir-shah',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/image-c2u8arD1VITI.png',
        },
        {
          name: 'Vivek Jain',
          designation: 'Co-Founder & CBO, Stride Green ',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/vivek-jain',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/ViveksPhotograph-VbXYm3y8yCGv.JPG',
        },
        {
          name: 'Kapil Bansal',
          designation: 'Senior Partner, EY Parthenon',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/ey-kapil-bansal-OaJNALBTXayLi.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/kapil-bansal',
        },
      ],
      ytLink: 'https://youtu.be/yEZd9Gfmpbk?feature=shared',
    },
    {
      id: 'Day1_8',
      timing: {
        start: '02:20 PM',
        end: '02:40 PM',
      },
      normalHeading:
        'Start-up Showcase Session: ‘IVCA x Sustainability Mafia Innovators Spotlight (4 Start-Ups)',
      ytLink: 'https://youtu.be/gkR3LPuKecg?feature=shared',
    },
    {
      id: 'Day1_8',
      timing: {
        start: '02:40 PM',
        end: '03:10 PM',
      },
      normalHeading: 'Fireside Chat',
      //   ytLink: 'https://youtu.be/2LH-NK5yQow?feature=shared',
    },
    {
      id: 'Day1_9',
      timing: {
        start: '03:10 PM',
        end: '03:30 PM',
      },
      accentTag: 'Fireside Chat',
      normalHeading:
        'Mobilizing Climate Finance: IFSCA as a Global Climate Finance Hub',
      speakers: [
        {
          name: 'Shri K. Rajaraman',
          designation:
            'Chairperson, International Financial Services Centres Authority (IFSCA)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/4871f73b-cbed-42cb-a3bc-e78df06c9eda-lDifGc0qNJXS.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/shri-k-rajaraman',
        },
        {
          name: 'Vipul Roongta',
          designation: 'Managing Director & CEO, HDFC Capital Advisors',
          //   profileImg:
          //     'https://static.levocdn.com/WGLBUT82/4871f73b-cbed-42cb-a3bc-e78df06c9eda-lDifGc0qNJXS.jpg',
          //   link: 'https://www.ivca.in/greenReturns-2024/speakers/shri-k-rajaraman',
        },
      ],
      ytLink: 'https://youtu.be/T6dzCqdq-MM?feature=shared',
    },
    {
      id: 'Day1_10',
      timing: {
        start: '03:30 PM',
        end: '03:50 PM',
      },
      normalHeading: 'Networking High Tea',
    },
    {
      id: 'Day1_10',
      timing: {
        start: '03:50 PM',
        end: '04:00 PM',
      },
      accentTag: 'Report Launch',
      normalHeading: 'Family Office Report by Sundaram Alternates',
      speakers: [
        {
          name: 'Shri Jayant Sinha',
          designation:
            'Former Union Minister of State for Finance and Civil Aviation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-29at174249-HXVetJKDJbnv.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/jayant-sinha',
        },
        {
          name: 'Vikaas M Sachdeva',
          designation: 'Managing Director, Sundaram Alternates',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-22at25622PM-R6eiN5RLu56k.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/vikaas-m-sachdeva',
        },
        {
          name: 'Karthik B. Athreya',
          designation:
            'Director & Head - Strategy - Alternative Credit, Sundaram Alternates',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/IMG0058-OaJwLBvmnLgl.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/karthik-athreya',
        },
        {
          name: 'Mr. Ashish Gulati',
          designation: 'Zonal Head – North, Sundaram Alternates',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/1522524835612-XZbabFfsf4LA.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/karthik-athreya',
        },
      ],
      ytLink: 'https://youtu.be/rbqDPCrjVfs?feature=shared',
    },
    {
      id: 'Day1_11',
      timing: {
        start: '04:00 PM',
        end: '04:40 PM',
      },
      accentTag: 'Panel Discussion',
      normalHeading:
        'Building a Sustainable Legacy: Family Office Strategies for Climate Impact',
      speakers: [
        {
          name: 'Rahul Goswami',
          designation: ' Co-Founder and Managing Partner, Greenstone Fund ',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/rahul-goswami',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/rahulgoswami-oilvrVb6A5Ab.jpeg',
        },
        {
          name: 'Nitai Utkarsh',
          designation:
            'Lead – Investment Strategy & Chairman’s Family Office Hero MotoCorp Limited',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/nitai-utkarsh',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Nitai-Utkarsh-2EYW54JxWpcV.webp',
        },
        {
          name: 'Manu Iyer',
          designation: 'Managing Partner, Bluehill Capital',
        },
        {
          name: 'Vikaas M Sachdeva',
          designation: 'Managing Director, Sundaram Alternates (Moderator)',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-22at25622PM-R6eiN5RLu56k.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/vikaas-m-sachdeva',
        },
      ],
      ytLink: 'https://youtu.be/2jU9h98D7Lc?feature=shared',
    },
    {
      id: 'Day1_12',
      timing: {
        start: '04:40 PM',
        end: '05:00 PM',
      },
      accentTag: 'Fireside Chat',
      normalHeading:
        'Raising ambition and accelerating delivery of climate finance',
      speakers: [
        {
          name: 'Amar Bhattacharya',
          designation:
            'Senior Fellow – Global Economy and Development, Center for Sustainable Development, Brookings and Co-Chair, Independent High-Level Expert Group on Climate Finance',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/bhattacharyaaportrait-FUGmXjB9iObN.webp',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/amar-bhattacharya',
        },
        {
          name: 'Akhilesh Tilotia',
          designation:
            'Co-Chair, IVCA Climate & Sustainability Council and Distinguished Fellow, Infravision Foundation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/akhilesh-tilotia-2-MqnQyVqwEvwU.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/akhilesh-tilotia',
        },
      ],
      ytLink: 'https://youtu.be/2LH-NK5yQow?feature=shared',
    },
    {
      id: 'Day1_13',
      timing: {
        start: '05:00 PM',
        end: '05:20 PM',
      },
      accentTag: 'Report Launch and Presentation',
      normalHeading:
        'IVCA-EY Parthenon: Energy Transition – India’s Journey to Net Zero',
      speakers: [
        {
          name: 'Shri Jayant Sinha',
          designation:
            'Former Union Minister of State for Finance and Civil Aviation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-29at174249-HXVetJKDJbnv.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/jayant-sinha',
        },
        {
          name: 'Kapil Bansal',
          designation: 'Senior Partner, EY Parthenon',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/ey-kapil-bansal-OaJNALBTXayLi.png',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/kapil-bansal',
        },
        {
          name: 'Pratibha Jain',
          designation:
            'Co-chair, IVCA Climate & Sustainability Council and Head of Strategy and Group General Counsel, Everstone Group',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/pratibhajain-XZbjbF86MPhV.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/pratibha-jain',
        },
        {
          name: 'Akhilesh Tilotia',
          designation:
            'Co-Chair, IVCA Climate & Sustainability Council and Distinguished Fellow, Infravision Foundation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/akhilesh-tilotia-2-MqnQyVqwEvwU.jpg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/akhilesh-tilotia',
        },
      ],
      ytLink: 'https://youtu.be/Q77khoEVRk0?feature=shared',
    },
    {
      id: 'Day1_14',
      timing: {
        start: '05:20 PM',
        end: '05:30 PM',
      },
      normalHeading: 'Keynote Address (Virtual)',
      //   normalHeading:
      //     'By U.S. International Development Finance Corporation (DFC) (Virtual) ',
      speakers: [
        {
          name: 'Anna Shpitsberg',
          designation:
            'Chief Climate Officer, US Development Finance Corporation (DFC)',
        },
      ],
    },
    {
      id: 'Day1_14',
      timing: {
        start: '05:30 PM',
        end: '05:40 PM',
      },
      normalHeading: 'Keynote Address',
      //   normalHeading: 'By International Monetary Fund (IMF) (Virtual) ',
      speakers: [
        {
          name: 'Ranil Salgado',
          designation:
            ' IMF Senior Resident Representative for India and Bhutan, International Monetary Fund (IMF)',
        },
      ],
      ytLink: 'https://youtu.be/cOetcBAVyCI?feature=shared',
    },
    {
      id: 'Day1_14',
      timing: {
        start: '05:40 PM',
        end: '05:50 PM',
      },
      accentTag: 'Keynote Address',
      normalHeading: 'Start-up Showcase Session ',
      listContent: [
        'IVCA x Sustainability Mafia Innovators Spotlight (2 Start-Ups)',
      ],
      ytLink: 'https://youtu.be/VuBxSdstfB4?feature=shared',
    },
    {
      id: 'Day1_14',
      timing: {
        start: '05:50 PM',
        end: '06:15 PM',
      },
      accentTag: 'Keynote Address',
      normalHeading:
        "Attracting a trillion dollars for India's Climate Financing",
      speakers: [
        {
          name: 'Shri Jayant Sinha',
          designation:
            'Former Union Minister of State for Finance and Civil Aviation',
          profileImg:
            'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-29at174249-HXVetJKDJbnv.jpeg',
          link: 'https://www.ivca.in/greenReturns-2024/speakers/jayant-sinha',
        },
      ],
      ytLink: 'https://youtu.be/asK2EeocDI8?feature=shared',
    },
    {
      id: 'Day1_15',
      timing: {
        start: '06:15 PM',
        end: '06:20 PM',
      },
      normalHeading: 'Closing Remarks',
    },
    {
      id: 'Day1_16',
      timing: {
        start: '06:20 PM',
        end: '09:50 PM',
      },
      normalHeading: 'Networking Dinner and Cocktails',
    },
  ],
];

// eslint-disable-next-line arrow-body-style
const Agenda = () => {
  return (
    <Container maxW="container.lg">
      <Box padding={{ xs: '50px 0px', md: '100px 50px 56px' }} mt="10px">
        <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          December 2nd 2024
        </Text>
        {/* <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="black"
          textAlign="left"
          mb="2rem"
        >
          To be announced...
        </Text> */}

        <AgendaWrapper
          itemsContainerProps={{
            px: '0',
          }}
          accordionProps={{
            defaultIndex: [2],
          }}
        >
          {agendaDay1[0].map((item) => (
            <EventCard
              key={item.id}
              event={item}
              labelTextColor="#00A633"
              customSpeakerStyles
            />
          ))}
        </AgendaWrapper>
      </Box>
    </Container>
  );
};

export default Agenda;
